import Expander from '../Expander';

import AddressWithLink from './AddressWithLink';

const OutletSection = ({ outlets, handleOutletDialog }) => (
  <div>
    <Expander
      summary="Outlets"
      isLast={true}
      details={
        <div className="outlets">
          {outlets?.slice(0, 6).map((outlet) => {
            const { name, fullAddress, contactInfo, openingHours, lat, lng } = {
              ...outlet,
            };
            const { phoneNumber } = { ...contactInfo };
            return (
              <div className="outlet" key={outlet.id}>
                <h5>{name}</h5>
                <AddressWithLink address={fullAddress} lat={lat} lng={lng} />
                <div className="outlet-info">
                  {phoneNumber && <a href={`tel:${phoneNumber}`}>+65 {phoneNumber}</a>}
                  <br />
                  {openingHours?.legacyOpeningHours}
                </div>
              </div>
            );
          })}
          {outlets?.length > 6 && (
            <a
              data-testid="see-all-outlets-button"
              href="#/"
              className="outlets-see-more"
              onClick={handleOutletDialog}
            >
              See all {outlets?.length} outlets
            </a>
          )}
        </div>
      }
    />
  </div>
);
export default OutletSection;
